'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { UnstyledButton } from '@b-stock/fe-core/bstock-next/components'
import { Button } from '@b-stock/fe-core/bstock-react'
import { Typography } from '@b-stock/fe-core/design-system'
import { designColors } from '@b-stock/fe-core/theme'

// WARNING: Even though this file may appear to be "new" (as of June 2025), it does not follow
// modern B-Stock standards, and has many aspects of the CSS rules and component structure that
// are sub-optimal.
// This was a near straight copy of @/buyer-portal/components/layouts/shared/Header/SearchBar/ui.ts
// with only very minimal changes - just the bare minimum to fix it for the slightly reduced height.
// Please try to avoid following the patterns set in this file until time is spent cleaning it up.
// As soon as it is cleaned up, this comment should be removed.
// Related discussion: https://gitlab.bstock.io/b-stock/code/three-mp/fe/home-portal/-/merge_requests/514#note_435275

export const InputSearch = styled.input`
  ${Typography.Body2}
  flex-grow: 1;
  max-width: 20rem;
  box-sizing: border-box;
  outline: none;
  height: 100%;
  padding: 0 1.75rem 0 0.75rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  transition: 0.3s;
  border: solid ${designColors.neutral.mediumGray};
  border-width: 0.0625rem 0 0.0625rem 0.0625rem;
  border-radius: 0.25rem 0 0 0.25rem;

  &::placeholder {
    ${Typography.Body2}
    color: ${designColors.neutral.darkGray};
  }

  &:focus {
    border-color: ${designColors.primary.brightBlue};
  }
`

export const ClearButton = styled(UnstyledButton)`
  margin-left: -2.25rem;
  width: 2.25rem;
  height: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const ClearIcon = styled(FontAwesomeIcon)`
  font-size: 1rem;
  color: ${designColors.neutral.darkGray};
`

export const SubmitButton = styled(Button)`
  && {
    display: flex;
    width: 2.25rem;
    height: 100%;
    padding: 0.5rem;
    align-items: center;
    justify-content: center;
    border-radius: 0 0.25rem 0.25rem 0;
    cursor: pointer;
    transition: 0.3s;
    background: ${designColors.neutral.white};
    border: solid ${designColors.neutral.mediumGray};
    border-width: 0.0625rem 0.0625rem 0.0625rem 0;

    input:focus ~ & {
      background: ${designColors.primary.hoverOverlay};
      border-color: ${designColors.primary.brightBlue};
    }
  }
`

export const SearchIcon = styled(FontAwesomeIcon)`
  color: ${designColors.neutral.darkGray};

  && {
    width: 0.75rem;
  }

  input:focus ~ ${SubmitButton} & {
    color: ${designColors.primary.brightBlue};
  }
`

export const SearchForm = styled.form`
  flex-shrink: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 2.25rem;
  min-height: 2.25rem;
`
